import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-get-name',
    templateUrl: './get-name.component.html',
    standalone: false
})
export class AddGetNameComponent {
  @Input() name: string = null;
  @ViewChild('fileForm') form: any;
  @Input() file:any
  constructor(public activeModal: NgbActiveModal) {}
  close(name = null) {
    if (name) {
      this.activeModal.close(name);
    } else {
      this.form.controls.filename.markAsTouched();
      this.form.controls.filename.markAsDirty();
    }
  }
}
